export default __webpack_public_path__ + "src/images/galleries/0/preface_en-4fc79b.png";